<div class="container-fluid mb-4">{{FORM_PREFIX + 'info' | translate}}</div>
<ds-form *ngIf="formModel"
         [formId]="FORM_PREFIX"
         [formModel]="formModel"
         [formGroup]="formGroup"
         [displaySubmit]="false"
         [displayCancel]="false">
</ds-form>
<div id="notLongEnough" class="container-fluid text-danger" *ngIf="formGroup.hasError('notLongEnough')">{{FORM_PREFIX + 'error.password-length' | translate}}</div>
<div id="notSame" class="container-fluid text-danger" *ngIf="formGroup.hasError('notSame')">{{FORM_PREFIX + 'error.matching-passwords' | translate}}</div>
<div id="emptyPassword" class="container-fluid text-danger" *ngIf="(formGroup.dirty || formGroup.touched) && formGroup.hasError('emptyPassword')">{{FORM_PREFIX + 'error.empty-password' | translate}}</div>
